<template>
  <div class="row">
    <div class="col-12 mb-4">
      <div class="text-dark-50 font-size-sm">Toplam Çalışma Saati (1 FTE)</div>
      <div class="text-dark h1 font-weight-bold m-0 p-0 my-1">
        {{ $customFunctions.moneyFixGlobal(selectedItem.fte) }}
      </div>
      <div class="text-dark-75 font-size-sm">Saat / Yıl</div>
    </div>
    <div
      class="col-12 mb-4 text-dark-75"
      v-if="selectedItem.description"
      v-html="selectedItem.description"
    ></div>
    <div class="col-12 mb-2 text-dark-75 d-flex align-items-center">
      <div>
        <div class="text-dark-50 font-size-sm mb-2">Haftalık Çalışma Saati</div>
        <div class="text-dark font-weight-bold m-0 p-0 my-1">
          {{ selectedItem.weeklyWorkingHours }}
        </div>
      </div>
    </div>
    <div class="col-12 mb-4 text-dark-75">
      <div class="text-dark-50 font-size-sm mb-2">Çalışma Günleri</div>

      <div class="d-flex align-items-center mt-4">
        <div v-for="workingDay in workingDays" :key="workingDay.id">
          <div
            class="border rounded-sm mr-2 font-weight-bolder font-size-md"
            :class="
              selectedItem.workingDays &&
              selectedItem.workingDays.includes(workingDay.value)
                ? 'bg-light-primary border-primary text-primary px-5 pt-5'
                : 'bg-white border-light text-dark-50 px-5 pt-5 pb-6'
            "
          >
            {{ workingDay.text }}
            <div
              v-if="
                selectedItem.workingDays &&
                selectedItem.workingDays.includes(workingDay.value)
              "
              class="text-right"
            >
              <i class="fa fa-check text-primary font-size-sm"></i>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="col-12 mb-4 text-dark-75">
      <div class="text-dark-50 font-size-sm mb-2">Tatiller</div>
    </div>
    <div
      v-if="
        selectedItem.workCalendarHolidays &&
        selectedItem.workCalendarHolidays.length > 0
      "
      class="w-100 px-5"
    >
      <div
        v-for="holiday in selectedItem.workCalendarHolidays"
        :key="holiday.id"
        class="bg-modussoft-light border border-light rounded-sm p-5 mb-5 d-flex align-items-center justify-content-between w-100"
      >
        <div class="d-flex flex-column">
          <div>
            {{ holiday.name }}
            <b>{{ holiday.holidayTotalHours }} Saat</b>
          </div>
        </div>
        <div class="font-size-sm">
          {{
            holiday.holidayStartTime
              ? $customFunctions.setMomentWithFormat(
                  holiday.holidayStartTime,
                  'DD.MM.yyyy'
                )
              : '-'
          }}
          /
          {{
            holiday.holidayEndTime
              ? $customFunctions.setMomentWithFormat(
                  holiday.holidayEndTime,
                  'DD.MM.yyyy'
                )
              : '-'
          }}
        </div>
      </div>
    </div>
    <div v-else class="px-5">Tatil girişi yapılmamış.</div>
  </div>
</template>

<script>
export default {
  name: 'DetailView',
  props: {
    selectedItem: String | Object,
  },
  data() {
    return {
      workingDays: [
        {
          value: 0,
          text: 'PZT',
        },
        {
          value: 1,
          text: 'SAL',
        },
        {
          value: 2,
          text: 'ÇAR',
        },
        {
          value: 3,
          text: 'PER',
        },
        {
          value: 4,
          text: 'CUM',
        },
        {
          value: 5,
          text: 'CMT',
        },
        {
          value: 6,
          text: 'PZR',
        },
      ],
    };
  },
};
</script>
